import React, { useState } from 'react';
import API from '../services/api';

export default function Login({ setAuth }) {
  const [password, setPassword] = useState('');
  // Crew - drivers and offsiders alike - sign in with their own username; the
  // operator's single master password still works with this left blank.
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const res = await API.post('/auth/login',
        username.trim() ? { username: username.trim(), password } : { password });
      if (res.data.access_token) {
        localStorage.setItem('dav_token', res.data.access_token);
        localStorage.setItem('dav_role', res.data.role || 'admin');
        localStorage.setItem('dav_username', res.data.username || '');
        // Drives the forced change-password screen in App.js.
        localStorage.setItem('dav_must_change', res.data.must_change_password ? '1' : '0');
        if (res.data.driver_id) localStorage.setItem('dav_driver_id', res.data.driver_id);
        else localStorage.removeItem('dav_driver_id');
        API.defaults.headers.common['Authorization'] = `Bearer ${res.data.access_token}`;
        setAuth(true);
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-slate-900 border border-slate-800 rounded-3xl p-8 shadow-2xl relative overflow-hidden">
        {/* Abstract Background Decoration */}
        <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 bg-blue-600/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-64 h-64 bg-orange-600/10 rounded-full blur-3xl"></div>
        
        <div className="relative z-10">
          <div className="flex flex-col items-center mb-8">
            <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center shadow-lg shadow-blue-600/20 mb-4">
              <span className="text-3xl font-bold text-white">DAV</span>
            </div>
            <h1 className="text-2xl font-bold text-white">DAV Transport</h1>
            <p className="text-slate-400 text-sm mt-1">Secure Dashboard Portal</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-2">Username <span className="text-slate-500 font-normal">(crew)</span></label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoCapitalize="none"
                autoCorrect="off"
                className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all placeholder:text-slate-600 mb-4"
                placeholder="Drivers and offsiders — blank for the operator login"
              />
              <label className="block text-sm font-medium text-slate-300 mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all placeholder:text-slate-600"
                placeholder="Enter password..."
                required
              />
            </div>
            
            {error && (
              <div className="bg-red-500/10 border border-red-500/30 text-red-400 text-sm p-3 rounded-lg text-center">
                {error}
              </div>
            )}
            
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-3 px-4 rounded-xl shadow-lg shadow-blue-600/20 transition-all disabled:opacity-50 disabled:hover:bg-blue-600"
            >
              {loading ? 'Authenticating...' : 'Secure Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
